<div class="flex gap-2 w-full bg-white items-center md:flex-row flex-col">

    <img src="../../assets/image/search.svg" alt="" class="" />

    <input 
      placeholder="Search {{placeholder}} Here..."
      class="w-full border p-2 rounded-md outline-none"
      formControlName="search"
      (keyup)="onKeyUp($event)"
    />
 

  </div>